import React from 'react';
import { Heart, Gem } from 'lucide-react';

export function GuestMapLocationBadge({
  hiddenGemsOn = true,
  onToggleHiddenGems,
  hiddenGemsCount = 0,
  openingVenueId,
  savedOnly = false,
  onToggleSaved,
  savedCount = 0,
}) {
  return (
    <div
      style={{
        padding: '0 16px 8px',
        flexShrink: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 10,
      }}
    >
      {onToggleHiddenGems ? (
        <button
          type="button"
          data-testid="map-hidden-gems-toggle"
          aria-pressed={hiddenGemsOn}
          onClick={() => onToggleHiddenGems()}
          style={{
            display: 'inline-flex', alignItems: 'center', gap: 6,
            padding: '6px 12px', borderRadius: 9999,
            background: hiddenGemsOn
              ? 'linear-gradient(135deg, #7C3AED 0%, #4F46E5 100%)'
              : 'var(--surface)',
            border: hiddenGemsOn ? '1px solid transparent' : '1px solid var(--card-border)',
            color: hiddenGemsOn ? '#FFFFFF' : 'var(--text)',
            fontFamily: "'Inria Serif', serif", fontSize: 12.5, fontWeight: 700,
            cursor: 'pointer',
            boxShadow: hiddenGemsOn
              ? '0 8px 18px rgba(124, 58, 237, 0.32)'
              : 'var(--premium-shadow-nested)',
            transition: 'transform 160ms ease, box-shadow 200ms ease',
            transform: hiddenGemsOn ? 'translateY(-1px)' : 'translateY(0)',
          }}
        >
          <Gem
            size={13}
            strokeWidth={2.2}
            color={hiddenGemsOn ? '#FFFFFF' : '#7C3AED'}
          />
          Hidden Gems
          {hiddenGemsOn && hiddenGemsCount > 0 ? (
            <span
              data-testid="map-hidden-gems-count"
              style={{
                minWidth: 17, height: 17, padding: '0 5px',
                borderRadius: 999,
                display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                fontSize: 10.5, fontWeight: 700,
                background: 'rgba(255,255,255,0.24)',
                color: '#FFFFFF',
              }}
            >
              {hiddenGemsCount}
            </span>
          ) : null}
          {openingVenueId && <span data-testid="map-opening-chat-status" style={{ marginLeft: 6 }}>· Opening chat…</span>}
        </button>
      ) : <span />}
      {onToggleSaved ? (
        <button
          type="button"
          data-testid="map-saved-toggle"
          aria-pressed={savedOnly}
          onClick={() => onToggleSaved()}
          style={{
            display: 'inline-flex', alignItems: 'center', gap: 5,
            padding: '6px 11px', borderRadius: 9999,
            background: savedOnly
              ? 'linear-gradient(135deg, #FF5874, #E5304F)'
              : 'var(--status-danger-surface)',
            border: savedOnly ? '1px solid transparent' : '1px solid var(--card-border)',
            color: savedOnly ? '#FFFFFF' : 'var(--status-danger-text)',
            fontFamily: "'Inria Serif', serif", fontSize: 12.5, fontWeight: 700,
            cursor: 'pointer',
            boxShadow: savedOnly
              ? '0 8px 18px rgba(229, 48, 79, 0.32)'
              : 'var(--premium-shadow-nested)',
            transition: 'transform 160ms ease, box-shadow 200ms ease',
            transform: savedOnly ? 'translateY(-1px)' : 'translateY(0)',
          }}
        >
          <Heart
            size={12}
            strokeWidth={2.2}
            fill={savedOnly ? '#FFFFFF' : 'var(--status-danger-text)'}
            color={savedOnly ? '#FFFFFF' : 'var(--status-danger-text)'}
          />
          Saved
          {savedCount > 0 ? (
            <span
              data-testid="map-saved-toggle-count"
              style={{
                minWidth: 17, height: 17, padding: '0 5px',
                borderRadius: 999,
                display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                fontSize: 10.5, fontWeight: 700,
                background: savedOnly ? 'rgba(255,255,255,0.24)' : 'rgba(229, 48, 79, 0.14)',
                color: savedOnly ? '#FFFFFF' : 'var(--status-danger-text)',
              }}
            >
              {savedCount}
            </span>
          ) : null}
        </button>
      ) : null}
    </div>
  );
}
